import API from "Services/Api";
import { IAResponse } from "Pages/PreBudgetConvertionIA/interface";

export const processMedicalClaimWithIA = async (
  fileBlobs: Blob[]
): Promise<IAResponse> => {
  const formData = new FormData();

  fileBlobs.forEach((blob, index) => {
    // Detectar tipo correto do arquivo
    const getFileExtension = (blob: Blob): string => {
      if (blob.type.includes("pdf")) return "pdf";
      if (blob.type.includes("jpeg") || blob.type.includes("jpg")) return "jpg";
      if (blob.type.includes("png")) return "png";
      return "pdf"; // fallback
    };

    const fileName = `document_${index + 1}.${getFileExtension(blob)}`;
    const file = new File([blob], fileName, { type: blob.type });
    formData.append("files[]", file);
  });

  const response = await API.post("/medical-claim-file/process", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};
